import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IProductTextStyles } from "./ProductText.types"

export const ProductTextStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IProductTextStyles>
> = (theme: IPartialTheme) => ({
    root: {},
    shortText: {},
    longText: {},
    link: {
        color: theme.palette?.themePrimary,
        cursor: "pointer",
        textDecoration: "none"
    }
})
